




















































import {
    Component,
    Vue,
    Prop
} from "vue-property-decorator";
import SingleFileUploaderComponent from "@/components/uploaders/SingleFileUploader.vue";
import {
    MetadataConfiguration,
    MetadataConfigurationField,
    MetadataFieldTypes
} from "@/server/app.dtos";
import {
    concatUrls
} from "@/utilities/url";

@Component({
    components: {
        SingleFileUploader: SingleFileUploaderComponent
    }
})
export default class MetadataPresentComponent extends Vue {
    @Prop() value!: MetadataConfiguration;
    @Prop() folder!: string;

    isSelector(field: MetadataConfigurationField): boolean {
        return (
            field.type == MetadataFieldTypes.SelectorSingle ||
            field.type == MetadataFieldTypes.SelectorMultiple
        );
    }

    isDate(field: MetadataConfigurationField): boolean {
        return field.type == MetadataFieldTypes.Date;
    }

    isTime(field: MetadataConfigurationField): boolean {
        return field.type == MetadataFieldTypes.Time;
    }

    isDateTime(field: MetadataConfigurationField): boolean {
        return field.type == MetadataFieldTypes.Datetime;
    }

    isText(field: MetadataConfigurationField): boolean {
        return field.type == MetadataFieldTypes.Text;
    }

    isHtml(field: MetadataConfigurationField): boolean {
        return field.type == MetadataFieldTypes.Html;
    }

    isSelectorMultiple(field: MetadataConfigurationField): boolean {
        return field.type == MetadataFieldTypes.SelectorMultiple;
    }

    isSelectorSingle(field: MetadataConfigurationField): boolean {
        return field.type == MetadataFieldTypes.SelectorSingle; // Fazer isugal a isto
    }

    isInteger(field: MetadataConfigurationField): boolean {
        return field.type == MetadataFieldTypes.Integer;
    }

    isDecimal(field: MetadataConfigurationField): boolean {
        return field.type == MetadataFieldTypes.Decimal;
    }

    isCurrency(field: MetadataConfigurationField): boolean {
        return field.type == MetadataFieldTypes.Currency;
    }

    isGpsCoordinates(field: MetadataConfigurationField): boolean {
        return field.type == MetadataFieldTypes.GpsCoordinates;
    }

    isFile(field: MetadataConfigurationField): boolean {
        return field.type == MetadataFieldTypes.File;
    }

    isBoolean(field: MetadataConfigurationField): boolean {
        return field.type == MetadataFieldTypes.Boolean;
    }
    onSelectFile(field: any, file: any) {
        field.value = file
    }

    getFilenameSrc(value: string): string {
        return value ? concatUrls(process.env.VUE_APP_CDN_URL, value) : "#";
    }

    onSelectBoolean(field: any, arg: any) {
        field.value = arg.toString()
    }

    onSelectedOption(field: MetadataConfigurationField, arg: any) {
        field.options = []
        field.options.push(arg);
    }

     onSelectedOptionMultiple(field: MetadataConfigurationField, arg: any) {
        if (field) {
            if (!field.options) {
                field.options = [];
            }
            field.options.push(arg);
        }
    }
}
